
import React, { useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import QuantityPresetSelector from "../QuantityPresetSelector";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import UnitPickerDialog from "../../add-item/UnitPickerDialog";

interface ItemQuantitySectionProps {
  quantity: string;
  setQuantity: (quantity: string) => void;
  quantityPresets: string[];
  onQuantitySelect: (value: string) => void;
  unit: string;
  setUnit: (unit: string) => void;
}

const ItemQuantitySection = ({
  quantity,
  setQuantity,
  quantityPresets,
  onQuantitySelect,
  unit,
  setUnit
}: ItemQuantitySectionProps) => {
  const { theme } = useThemeConfig();
  const [isUnitDialogOpen, setIsUnitDialogOpen] = useState(false);

  return (
    <>
      <div className="grid grid-cols-2 gap-4 mb-2">
        <div className="space-y-2">
          <Label htmlFor="item-unit-display">Un. Misura</Label>
          <div className="flex items-center">
            <div
              id="item-unit-display"
              className="flex-1 border rounded-md px-2 py-2"
              style={{
                backgroundColor: theme.backgroundColor,
                color: theme.primaryColor || theme.textColor,
                borderRadius: theme.cardBorderRadius,
              } as React.CSSProperties}
            >
              {unit}
            </div>
            <Button
              aria-label="Modifica unità"
              type="button"
              variant="outline"
              size="icon"
              className="ml-2"
              onClick={() => setIsUnitDialogOpen(true)}
            >
              <Pencil className="h-4 w-4" />
            </Button>
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="item-quantity">Quantità</Label>
          <Input
            id="item-quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="1"
            readOnly
            style={{
              borderRadius: theme.cardBorderRadius,
              backgroundColor: theme.backgroundColor || '#ffffff',
              color: theme.primaryColor,
            }}
            onFocus={(e) => {
              setTimeout(() => {
                e.target.removeAttribute("readonly");
              }, 100);
            }}
          />
        </div>
      </div>

      <UnitPickerDialog
        open={isUnitDialogOpen}
        onOpenChange={setIsUnitDialogOpen}
        selectedUnit={unit}
        onSelect={(val) => setUnit(val)}
      />

      <QuantityPresetSelector
        presets={quantityPresets}
        selectedValue={quantity}
        onSelect={onQuantitySelect}
      />
    </>
  );
};

export default ItemQuantitySection;
